// src/utils/websocket-client.js
export default class WebSocketClient {
    constructor(url, options = {}) {
        this.url = url
        this.options = Object.assign({
            heartTime: 10000,      // 心跳间隔
            reconnInterval: 5000,  // 重连间隔
            reconnMaxAttempts: 5   // 最大重连次数
        }, options)

        // 状态管理
        this.ws = null
        this.status = 'DISCONNECTED' // 新增连接状态跟踪
        this.reconnAttempts = 0
        this.heartTimer = null
        this.reconnTimer = null
        this.isManualClose = false

        // 事件回调
        this.callbacks = {
            onopen: null,
            onmessage: null,
            onreconnect: null,
            onclose: null
        }
    }

    connect() {
        if (this.pendingReconnect) return
        this.pendingReconnect = true

        // 清理旧连接
        this._cleanupConnection()

        // console.log('Initializing new connection...')
        this.status = 'CONNECTING'
        this.ws = new WebSocket(this.url)

        this._bindEvents()
    }
    // 事件绑定封装
    _bindEvents() {
        this.ws.onopen = (e) => {
            this.pendingReconnect = false
            this.status = 'CONNECTED'
            // console.log('WebSocket connected')
            this.reconnAttempts = 0
            // this.startHeartbeat()
            this.callbacks.onopen?.(e)
        }

        this.ws.onmessage = (e) => {
            this.handleMessage(e)
            this.callbacks.onmessage?.(e)
        }

        this.ws.onclose = (e) => {
            this.status = 'DISCONNECTED'
            // console.log('WebSocket closed', e)
            this._cleanupConnection()
            if (!this.isManualClose) this.reconnect()
            this.callbacks.onclose?.(e)
        }

        this.ws.onerror = (e) => {
            // console.error('WebSocket error:', e)
            this.ws.close()
        }
    }

    // 改进的发送方法
    send(data) {
        if (this.status !== 'CONNECTED') {
            console.warn('Message not sent - connection not ready')
            return false
        }

        try {
            this.ws.send(JSON.stringify(data))
            return true
        } catch (error) {
            console.error('Send message error:', error)
            return false
        }
    }

    // 基本心跳处理
    handleMessage(e) {
        try {
            const msg = JSON.parse(e.data)
            // if (msg.type === 'pong') {
            //     // 心跳响应处理
                
            //     this.send({type:'ping'})
            // }
            if (msg.type === 'ping') {
                // 心跳响应处理
                
                this.send({type:'pong'})
            }
        } catch { }
    }

    close() {
        this.isManualClose = true
        this.ws?.close()
    }

    // 改进后的重连方法
    reconnect() {
        if (this.reconnAttempts >= this.options.reconnMaxAttempts) {
            console.error(`Max reconnect attempts (${this.options.reconnMaxAttempts})`)
            return
        }

        clearTimeout(this.reconnTimer)
        this.reconnTimer = setTimeout(() => {
            this.reconnAttempts++
            console.log(`Reconnecting (attempt ${this.reconnAttempts})...`)
            this.connect()
            this.callbacks.onreconnect?.(this.reconnAttempts)
        }, this.options.reconnInterval)
    }
    // 清理连接资源
    _cleanupConnection() {
        this.pendingReconnect = false
        if (this.ws) {
            this.ws.onopen = null
            this.ws.onmessage = null
            this.ws.onclose = null
            this.ws.onerror = null
            if (this.ws.readyState === WebSocket.OPEN) {
                this.ws.close()
            }
            this.ws = null
        }
        this.clearHeartbeat()
    }

    startHeartbeat() {
        this.clearHeartbeat()
        this.heartTimer = setInterval(() => {
            this.send({ type: 'ping' })
        }, this.options.heartTime)
    }

    clearHeartbeat() {
        clearInterval(this.heartTimer)
    }

    on(event, callback) {
        if (this.callbacks.hasOwnProperty(event)) {
            this.callbacks[event] = callback
        }
        return this
    }
}